module.exports = __webpack_public_path__ + "static/img/einvest-pain-point-03.9f3dd2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/einvest-pain-point-03.png
// module id = H7oh
// module chunks = 1